import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetLeaguesByLeagueId = QueryFactory(SD.QueryTypes.GetLeaguesByLeagueId);
//# sourceMappingURL=QGetLeaguesByLeagueId.js.map